const initialState = () => ({
  isOpened: false,
  type: null,
  action: null,
  size: null,
  data: {},
  loading: false,
  error: null,
  onSuccessCallback: null
});

const ACTION_KEY = 'SAVE_UPDATE_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data, type, action, onSuccessCallback } = reduxAction.payload;
      return {
        ...state,
        data,
        type,
        action,
        size: data.size,
        onSuccessCallback,
        isOpened: true
      };
    }

    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: reduxAction.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      return initialState();
    }
    case `${ACTION_KEY}_NOTIFICATION_SHOW`: {
      return {
        ...state,
        error: reduxAction.payload
      };
    }
    case `${ACTION_KEY}_NOTIFICATION_HIDE`: {
      return {
        ...state,
        error: null
      };
    }
    default:
      return state;
  }
};

export default reducer;
